import * as React from 'react'
import Button from '@mui/material/Button'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import axios from 'axios'
import { api } from '../utils/api'
import { useNavigate } from 'react-router-dom'
import { saveToStorage } from '../utils/storage'
import { useDispatch } from 'react-redux'
import { currentUserActions } from '../redux/store'
import UserLayout from '../layouts/UserLayout'
import {
	CircularProgress,
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	OutlinedInput,
	Typography,
} from '@mui/material'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { borderFormat, mainGreen } from '../utils/color'

export default function SignIn() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [loadingLogin, setLoadingLogin] = React.useState(false)
	const [showPassword, setShowPassword] = React.useState(false)
	const handleClickShowPassword = () => setShowPassword((show) => !show)
	const loginUser = async function (data) {
		try {
			setLoadingLogin(true)
			const response = await axios({
				method: 'POST',
				url: api.LOGIN,
				data,
				withCredentials: true,
			})
			saveToStorage('current-user', response.data.user)
			dispatch(currentUserActions.isLogin(response.data.user))
			if (response.status === 200) {
				setLoadingLogin(false)
			}
			if (
				response.data.user.role !== 'admin' &&
				response.data.user.role !== 'director' &&
				response.data.user.role !== 'assistant'
			) {
				navigate(`/user/task`)
			} else {
				navigate('/admin/task/store')
			}
		} catch (error) {
			setLoadingLogin(false)
			alert(error.response.data.message)
		}
	}

	const handleSubmit = (event) => {
		event.preventDefault()
		const data = new FormData(event.currentTarget)
		const loginData = {
			email: data.get('email'),
			password: data.get('password'),
		}
		loginUser(loginData)
	}

	return (
		<UserLayout>
			{loadingLogin ? (
				<Box
					sx={{
						marginTop: '220px',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
					}}>
					<CircularProgress sx={{ color: mainGreen }} />
					<Typography sx={{ mt: 2 }}>Đang đăng nhập...</Typography>
				</Box>
			) : (
				<Container sx={{ padding: '20px', mt: '5%' }} maxWidth='sm'>
					<CssBaseline />
					<div style={{ textAlign: 'center', marginBottom: '1rem' }}>
						<img
							src='/img/logo.jpg'
							alt='logo'
							width='150px'
							style={{
								borderRadius: '1rem',
								border: borderFormat,
							}}
						/>
					</div>
					<Box component='form' onSubmit={handleSubmit} noValidate sx={{ m: 0 }}>
						<TextField margin='normal' fullWidth id='email' label='Email' name='email' autoComplete='email' autoFocus />
						<FormControl fullWidth sx={{ mt: 2 }}>
							<InputLabel htmlFor='outlined-adornment-password'>Mật khẩu</InputLabel>
							<OutlinedInput
								sx={{ pr: 2 }}
								id='outlined-adornment-password'
								type={showPassword ? 'text' : 'password'}
								autoComplete='password'
								autoFocus
								endAdornment={
									<InputAdornment position='end'>
										<IconButton aria-label='toggle password visibility' onClick={handleClickShowPassword} edge='end'>
											{showPassword ? <Visibility /> : <VisibilityOff />}
										</IconButton>
									</InputAdornment>
								}
								label='Mật khẩu'
								name='password'
								required
							/>
						</FormControl>
						<Button
							type='submit'
							fullWidth
							variant='contained'
							sx={{
								mt: 3,
								mb: 2,
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}>
							Đăng nhập
						</Button>
						<Box sx={{ textAlign: 'center' }}>
							<Button
								variant='text'
								size='small'
								sx={{
									color: mainGreen,
									'&:hover': { color: mainGreen },
								}}
								onClick={() => {
									navigate('/forgot-password')
								}}>
								Quên mật khẩu?
							</Button>
						</Box>
					</Box>
				</Container>
			)}
		</UserLayout>
	)
}
